import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function DogIdentifierPrivacyPolicy() {
  return (
    <div style={{ backgroundColor: '#0f0f0f', minHeight: '100vh', color: '#fff', padding: '60px 0' }}>
      <Container>
        <Row>
          <Col md={8} className="mx-auto">
            <div style={{ marginBottom: 32 }}>
              <Link to="/dog-identifier" style={{ color: '#E8855A', textDecoration: 'none', fontSize: 14 }}>
                ← Back to Dog Identifier
              </Link>
            </div>

            <h1 style={{ fontWeight: 800, marginBottom: 8 }}>Privacy Policy</h1>
            <p style={{ color: '#E8855A', fontWeight: 600, marginBottom: 4 }}>Dog Identifier – Breed Scanner</p>
            <p style={{ color: '#666', fontSize: 13, marginBottom: 40 }}>Last updated: April 8, 2026</p>

            <div style={{ lineHeight: 1.8, color: '#ccc' }}>

              <p>
                Westron ("we", "us", or "our") built the <strong>Dog Identifier – Breed Scanner</strong> app
                as a free app. This service is provided by Westron at no cost and is intended for use as-is.
              </p>

              <p>
                This page informs visitors regarding our policies on the collection, use, and disclosure
                of personal information when you use our service. By using Dog Identifier, you agree to
                the collection and use of information in accordance with this policy.
              </p>

              <h3 style={{ color: '#fff', marginTop: 36, marginBottom: 12 }}>Information We Collect</h3>
              <p>
                For a better experience while using our service, we may require certain information including
                access to your camera and photo library solely for the purpose of dog breed identification.
                Images you capture or select are processed by our AI model and are not stored on our servers
                beyond the duration of a single scan session.
              </p>
              <p>We may collect the following data to operate and improve the service:</p>
              <ul>
                <li>Account information (name, email) when you sign in with Google or Apple</li>
                <li>Device identifiers and push notification tokens for sending notifications</li>
                <li>Anonymous usage analytics (screens viewed, features used) via Firebase Analytics</li>
                <li>Crash reports to improve app stability</li>
              </ul>

              <h3 style={{ color: '#fff', marginTop: 36, marginBottom: 12 }}>Camera & Photo Library</h3>
              <p>
                The app requires camera and photo library access to let you take or select a photo of a dog
                for breed identification. Photos are processed in real time and are not uploaded to or
                retained on our servers after analysis is complete.
              </p>

              <h3 style={{ color: '#fff', marginTop: 36, marginBottom: 12 }}>Third-Party Services</h3>
              <p>The app uses the following third-party services that may collect information:</p>
              <ul>
                <li><a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer" style={{ color: '#E8855A' }}>Google Firebase</a> – Authentication, analytics, crash reporting, remote config</li>
                <li><a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer" style={{ color: '#E8855A' }}>Google AdMob</a> – Advertising</li>
                <li><a href="https://www.apple.com/legal/privacy/" target="_blank" rel="noreferrer" style={{ color: '#E8855A' }}>Apple Sign In</a> – Authentication on iOS</li>
              </ul>

              <h3 style={{ color: '#fff', marginTop: 36, marginBottom: 12 }}>Advertising</h3>
              <p>
                Dog Identifier is a free app supported by ads served by Google AdMob. AdMob may use
                your device's advertising identifier to show relevant ads. You can opt out of personalised
                advertising in your device settings. For more information, see{' '}
                <a href="https://policies.google.com/technologies/ads" target="_blank" rel="noreferrer" style={{ color: '#E8855A' }}>
                  Google's advertising policy
                </a>.
              </p>

              <h3 style={{ color: '#fff', marginTop: 36, marginBottom: 12 }}>Data Retention</h3>
              <p>
                We retain account data for as long as your account is active. You may request deletion
                of your data at any time by contacting us at the email below.
              </p>

              <h3 style={{ color: '#fff', marginTop: 36, marginBottom: 12 }}>Children's Privacy</h3>
              <p>
                Dog Identifier does not knowingly collect personal information from children under 13.
                If you believe your child has provided us with personal information, please contact us
                immediately and we will delete it.
              </p>

              <h3 style={{ color: '#fff', marginTop: 36, marginBottom: 12 }}>Changes to This Policy</h3>
              <p>
                We may update this privacy policy from time to time. You are advised to review this page
                periodically. Changes are effective immediately upon posting.
              </p>

              <h3 style={{ color: '#fff', marginTop: 36, marginBottom: 12 }}>Contact Us</h3>
              <p>
                If you have questions or concerns about this privacy policy, please contact us at{' '}
                <a href="mailto:privacy@westron.dev" style={{ color: '#E8855A' }}>privacy@westron.dev</a>.
              </p>
            </div>

            <div style={{ marginTop: 48, paddingTop: 24, borderTop: '1px solid #222', display: 'flex', gap: 16, flexWrap: 'wrap' }}>
              <Link to="/dog-identifier" style={{ color: '#E8855A', textDecoration: 'none', fontSize: 14 }}>Dog Identifier</Link>
              <Link to="/dog-identifier/terms" style={{ color: '#E8855A', textDecoration: 'none', fontSize: 14 }}>Terms &amp; Conditions</Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default DogIdentifierPrivacyPolicy;
